
import XHeader from 'vux/src/components/x-header/index.vue'


export default {
components: {
XHeader
},
data() {
return {
title: '',
content: '',
time:'',
show:false
};
},
mounted: function () {
document.title='天一互联'
this.$nextTick(v => {
const url = this.tianYiWebUrl + '/wechat/news/getDetail';
this.$http.get(url, {params: {id: this.$route.params.id}}).then(res => {
if (res.data.code == 200) {
if(res.data.data.outer_url !==null && res.data.data.outer_url.indexOf('http') === 0) {
window.location.href =res.data.data.outer_url;
return;
}
this.title = res.data.data.title
this.content = res.data.data.content
this.time= res.data.data.create_time
this.show = true;
} else {
window.history.go(-1)
}
})
});
}
}



// WEBPACK FOOTER //
// ./src/components/news/Detail.vue